export default "__VITE_ASSET__CG2Sy86Z__"